import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, vShow as _vShow, withDirectives as _withDirectives, createBlock as _createBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, normalizeStyle as _normalizeStyle, withModifiers as _withModifiers, vModelRadio as _vModelRadio, vModelText as _vModelText } from "vue";
import _imports_0 from './../../assets/image/qcpay/pc/alipay.png';
import _imports_1 from './../../assets/image/qcpay/pc/wechat.png';
import _imports_2 from './../../assets/image/qcpay/pc/pay-other.png';
import _imports_3 from '../../assets/image/delete.png';
import _imports_4 from './../../assets/image/close-icon.png';
const _hoisted_1 = {
  class: "pay-container"
};
const _hoisted_2 = {
  key: 0,
  class: "top-banner"
};
const _hoisted_3 = ["src"];
const _hoisted_4 = {
  key: 1,
  class: "active-icon-container"
};
const _hoisted_5 = ["src"];
const _hoisted_6 = {
  class: "pay-list-container"
};
const _hoisted_7 = {
  class: "top-list-m"
};
const _hoisted_8 = {
  class: "top-img"
};
const _hoisted_9 = ["src"];
const _hoisted_10 = {
  class: "top-info-container"
};
const _hoisted_11 = {
  class: "top-info"
};
const _hoisted_12 = {
  class: "top-info-list"
};
const _hoisted_13 = {
  class: "top-info-img"
};
const _hoisted_14 = ["src"];
const _hoisted_15 = {
  key: 1,
  class: "top-info-name"
};
const _hoisted_16 = {
  class: "bot-info-list"
};
const _hoisted_17 = {
  class: "bot-info-name"
};
const _hoisted_18 = {
  key: 0
};
const _hoisted_19 = {
  class: "bot-info-detail"
};
const _hoisted_20 = {
  key: 0
};
const _hoisted_21 = {
  class: "jf-container"
};
const _hoisted_22 = {
  class: "jf-num pc-web"
};
const _hoisted_23 = {
  class: "other-page-btn"
};
const _hoisted_24 = {
  key: 0,
  class: "pay-list-body"
};
const _hoisted_25 = {
  key: 0,
  class: "skeleton-container"
};
const _hoisted_26 = {
  key: 1,
  class: "pay-container-bot"
};
const _hoisted_27 = {
  class: "pay-container-left-container"
};
const _hoisted_28 = {
  key: 0,
  class: "h5-other-list-container"
};
const _hoisted_29 = {
  key: 0
};
const _hoisted_30 = {
  key: 0,
  class: "left-line"
};
const _hoisted_31 = {
  class: "pay-page"
};
const _hoisted_32 = ["onClick"];
const _hoisted_33 = ["src"];
const _hoisted_34 = {
  key: 0,
  class: "tips-title"
};
const _hoisted_35 = {
  key: 0
};
const _hoisted_36 = {
  key: 1
};
const _hoisted_37 = {
  key: 2
};
const _hoisted_38 = {
  key: 1,
  class: "tips-title"
};
const _hoisted_39 = {
  key: 0
};
const _hoisted_40 = {
  key: 1
};
const _hoisted_41 = {
  class: "top-pack-img new-pack-img"
};
const _hoisted_42 = {
  key: 0,
  class: "sale-img"
};
const _hoisted_43 = {
  class: "pack-img-mid"
};
const _hoisted_44 = ["src"];
const _hoisted_45 = {
  class: "limited-tips"
};
const _hoisted_46 = ["innerHTML"];
const _hoisted_47 = {
  class: "price-title"
};
const _hoisted_48 = ["onClick"];
const _hoisted_49 = ["onClick"];
const _hoisted_50 = {
  class: "pay-left-container"
};
const _hoisted_51 = {
  class: "left-line pc-left-line"
};
const _hoisted_52 = {
  class: "left-title"
};
const _hoisted_53 = {
  class: "pay-page"
};
const _hoisted_54 = ["onClick"];
const _hoisted_55 = {
  key: 0,
  class: "discount-icon"
};
const _hoisted_56 = ["src"];
const _hoisted_57 = {
  class: "mid-img-container"
};
const _hoisted_58 = {
  class: "mid-img"
};
const _hoisted_59 = ["src"];
const _hoisted_60 = {
  key: 0,
  class: "product-detail-img-list"
};
const _hoisted_61 = {
  key: 0,
  class: "product-add-icon"
};
const _hoisted_62 = {
  class: "product-detail-img"
};
const _hoisted_63 = ["src"];
const _hoisted_64 = {
  key: 0,
  class: "product-detail-img"
};
const _hoisted_65 = ["src"];
const _hoisted_66 = {
  class: "pack-title new-pack-title van-ellipsis"
};
const _hoisted_67 = {
  class: "pack-price-container"
};
const _hoisted_68 = {
  class: "price-title"
};
const _hoisted_69 = ["onClick"];
const _hoisted_70 = {
  class: "pack-gwc-body"
};
const _hoisted_71 = ["onClick"];
const _hoisted_72 = {
  class: "pack-gwc-body"
};
const _hoisted_73 = ["onClick"];
const _hoisted_74 = {
  class: "bot-ruler"
};
const _hoisted_75 = ["innerHTML"];
const _hoisted_76 = ["innerHTML"];
const _hoisted_77 = ["innerHTML"];
const _hoisted_78 = {
  key: 1,
  class: "h5-other-list-container"
};
const _hoisted_79 = {
  key: 0
};
const _hoisted_80 = {
  key: 0,
  class: "left-line"
};
const _hoisted_81 = {
  class: "left-title"
};
const _hoisted_82 = {
  class: "pay-page"
};
const _hoisted_83 = ["onClick"];
const _hoisted_84 = ["src"];
const _hoisted_85 = {
  key: 0,
  class: "tips-title"
};
const _hoisted_86 = {
  key: 0
};
const _hoisted_87 = {
  key: 1
};
const _hoisted_88 = {
  key: 2
};
const _hoisted_89 = {
  key: 1,
  class: "tips-title"
};
const _hoisted_90 = {
  key: 2,
  class: "tips-title"
};
const _hoisted_91 = {
  key: 0
};
const _hoisted_92 = {
  key: 1
};
const _hoisted_93 = {
  class: "top-pack-img new-pack-img"
};
const _hoisted_94 = {
  key: 0,
  class: "sale-img"
};
const _hoisted_95 = {
  class: "pack-img-mid"
};
const _hoisted_96 = ["src"];
const _hoisted_97 = {
  class: "limited-tips"
};
const _hoisted_98 = ["innerHTML"];
const _hoisted_99 = {
  class: "price-title"
};
const _hoisted_100 = ["onClick"];
const _hoisted_101 = ["onClick"];
const _hoisted_102 = {
  key: 0,
  class: "h5-other-list-container"
};
const _hoisted_103 = {
  class: "recharge-container",
  id: "recharge-block-container-sec"
};
const _hoisted_104 = {
  class: "recharge-block-container"
};
const _hoisted_105 = {
  class: "mid-img"
};
const _hoisted_106 = {
  class: "mid-img-bg"
};
const _hoisted_107 = ["src"];
const _hoisted_108 = {
  key: 0,
  class: "right-icon"
};
const _hoisted_109 = {
  key: 1,
  class: "over-block"
};
const _hoisted_110 = {
  class: "over-bot-title"
};
const _hoisted_111 = {
  class: "recharge-line-bw"
};
const _hoisted_112 = ["id"];
const _hoisted_113 = {
  key: 0,
  class: "recharge-icon"
};
const _hoisted_114 = {
  key: 1,
  class: "recharge-icon-fir"
};
const _hoisted_115 = {
  key: 2,
  class: "recharge-icon-sec"
};
const _hoisted_116 = {
  key: 0,
  class: "bot-next-tips"
};
const _hoisted_117 = {
  key: 0
};
const _hoisted_118 = {
  key: 1
};
const _hoisted_119 = ["innerHTML"];
const _hoisted_120 = {
  key: 1
};
const _hoisted_121 = {
  key: 2,
  class: "h5-bot-ruler"
};
const _hoisted_122 = ["innerHTML"];
const _hoisted_123 = ["innerHTML"];
const _hoisted_124 = ["innerHTML"];
const _hoisted_125 = ["innerHTML"];
const _hoisted_126 = {
  key: 3,
  class: "h5-pay-bot-btn list-bot",
  ref: "cart"
};
const _hoisted_127 = {
  class: "gwc-img"
};
const _hoisted_128 = {
  class: "gwc-num"
};
const _hoisted_129 = {
  class: "pay-bot-btn"
};
const _hoisted_130 = {
  class: "pay-btn"
};
const _hoisted_131 = {
  class: "agreement"
};
const _hoisted_132 = {
  class: "h5-pay-popup"
};
const _hoisted_133 = {
  class: "pay-info-container"
};
const _hoisted_134 = {
  class: "title"
};
const _hoisted_135 = {
  class: "info-container"
};
const _hoisted_136 = {
  class: "info-title"
};
const _hoisted_137 = {
  key: 0,
  class: "small-text"
};
const _hoisted_138 = {
  class: "info-detail-area"
};
const _hoisted_139 = {
  key: 0
};
const _hoisted_140 = {
  class: "game-merchandise-list none-gwc-list"
};
const _hoisted_141 = {
  class: "merchandise-container"
};
const _hoisted_142 = {
  class: "merchandise-left"
};
const _hoisted_143 = {
  class: "left-img"
};
const _hoisted_144 = ["src"];
const _hoisted_145 = {
  class: "merchandise-right"
};
const _hoisted_146 = {
  class: "right-title"
};
const _hoisted_147 = {
  class: "product-text"
};
const _hoisted_148 = {
  key: 0,
  class: "detail-list detail-list-container"
};
const _hoisted_149 = {
  class: "detail-right"
};
const _hoisted_150 = {
  key: 0
};
const _hoisted_151 = {
  key: 1
};
const _hoisted_152 = {
  key: 1,
  class: "detail-list detail-list-container"
};
const _hoisted_153 = {
  class: "detail-right"
};
const _hoisted_154 = {
  class: "right-detail"
};
const _hoisted_155 = {
  class: "price"
};
const _hoisted_156 = {
  key: 0
};
const _hoisted_157 = {
  class: "product-detail"
};
const _hoisted_158 = {
  key: 0
};
const _hoisted_159 = {
  class: "bingding-detail"
};
const _hoisted_160 = {
  class: "product-title-info"
};
const _hoisted_161 = {
  class: "detail-list"
};
const _hoisted_162 = {
  key: 0,
  class: "detail-right"
};
const _hoisted_163 = {
  key: 1,
  class: "detail-right"
};
const _hoisted_164 = {
  key: 0,
  class: "detail-list"
};
const _hoisted_165 = {
  class: "detail-right"
};
const _hoisted_166 = {
  key: 1,
  class: "detail-list"
};
const _hoisted_167 = {
  class: "detail-right"
};
const _hoisted_168 = {
  key: 2,
  class: "detail-list"
};
const _hoisted_169 = {
  class: "detail-right"
};
const _hoisted_170 = {
  class: "detail-list"
};
const _hoisted_171 = {
  key: 0,
  class: "detail-left detail-left-sec"
};
const _hoisted_172 = {
  key: 1,
  class: "detail-right"
};
const _hoisted_173 = {
  key: 0
};
const _hoisted_174 = {
  key: 1
};
const _hoisted_175 = {
  key: 2,
  class: "detail-right"
};
const _hoisted_176 = {
  key: 0
};
const _hoisted_177 = {
  key: 1
};
const _hoisted_178 = {
  key: 0,
  class: "pay-choice-list"
};
const _hoisted_179 = {
  key: 0,
  class: "pay-recommend"
};
const _hoisted_180 = {
  class: "agreement pay-tips"
};
const _hoisted_181 = {
  class: "h5-pay-bot-btn"
};
const _hoisted_182 = {
  key: 0,
  class: "pay-type-list"
};
const _hoisted_183 = {
  class: "pay-choice-list"
};
const _hoisted_184 = {
  key: 0,
  class: "pay-recommend"
};
const _hoisted_185 = {
  key: 1,
  class: "pay-bot-btn-h5"
};
const _hoisted_186 = {
  class: "gwc-img"
};
const _hoisted_187 = {
  class: "gwc-num"
};
const _hoisted_188 = {
  key: 2,
  class: "pay-bot-btn-h5"
};
const _hoisted_189 = {
  class: "total"
};
const _hoisted_190 = {
  class: "h5-pay-popup",
  id: "container",
  ref: "container"
};
const _hoisted_191 = {
  class: "pay-info-container"
};
const _hoisted_192 = {
  class: "title"
};
const _hoisted_193 = {
  class: "choice-title"
};
const _hoisted_194 = {
  class: "info-container"
};
const _hoisted_195 = {
  class: "info-title"
};
const _hoisted_196 = {
  class: "info-detail-area"
};
const _hoisted_197 = {
  class: "game-merchandise-list"
};
const _hoisted_198 = {
  class: "merchandise-container"
};
const _hoisted_199 = {
  class: "merchandise-left"
};
const _hoisted_200 = {
  class: "left-img"
};
const _hoisted_201 = ["src"];
const _hoisted_202 = {
  class: "merchandise-right"
};
const _hoisted_203 = {
  class: "right-title"
};
const _hoisted_204 = {
  class: "product-text"
};
const _hoisted_205 = {
  key: 0,
  class: "detail-list detail-list-container"
};
const _hoisted_206 = {
  class: "detail-right"
};
const _hoisted_207 = {
  key: 0
};
const _hoisted_208 = {
  key: 1
};
const _hoisted_209 = {
  key: 1,
  class: "detail-list detail-list-container"
};
const _hoisted_210 = {
  class: "detail-right"
};
const _hoisted_211 = {
  class: "right-detail"
};
const _hoisted_212 = {
  class: "price"
};
const _hoisted_213 = {
  class: "product-detail"
};
const _hoisted_214 = {
  key: 0
};
const _hoisted_215 = ["onClick"];
const _hoisted_216 = {
  class: "bingding-detail"
};
const _hoisted_217 = {
  class: "product-title-info"
};
const _hoisted_218 = {
  class: "detail-list gwc-detail-list"
};
const _hoisted_219 = {
  class: "detail-right"
};
const _hoisted_220 = {
  key: 0
};
const _hoisted_221 = {
  key: 0
};
const _hoisted_222 = {
  key: 0
};
const _hoisted_223 = {
  key: 0,
  class: "detail-list"
};
const _hoisted_224 = {
  class: "detail-right"
};
const _hoisted_225 = {
  key: 1,
  class: "detail-list"
};
const _hoisted_226 = {
  class: "detail-right"
};
const _hoisted_227 = {
  key: 2,
  class: "detail-list"
};
const _hoisted_228 = {
  class: "detail-right"
};
const _hoisted_229 = {
  class: "detail-list"
};
const _hoisted_230 = {
  key: 0,
  class: "detail-right"
};
const _hoisted_231 = {
  key: 1,
  class: "detail-right"
};
const _hoisted_232 = {
  class: "pay-choice-list"
};
const _hoisted_233 = {
  key: 0,
  class: "pay-recommend"
};
const _hoisted_234 = {
  class: "agreement pay-tips"
};
const _hoisted_235 = {
  class: "h5-pay-bot-btn"
};
const _hoisted_236 = {
  key: 0,
  class: "pay-type-list"
};
const _hoisted_237 = {
  class: "pay-choice-list"
};
const _hoisted_238 = {
  key: 0,
  class: "pay-recommend"
};
const _hoisted_239 = {
  class: "pay-icon-list"
};
const _hoisted_240 = {
  class: "pay-bot-btn-h5"
};
const _hoisted_241 = {
  class: "total"
};
const _hoisted_242 = {
  class: "new-role-game-container"
};
const _hoisted_243 = {
  class: "choice-top-list"
};
const _hoisted_244 = ["onClick"];
const _hoisted_245 = {
  class: "role-list-container-block"
};
const _hoisted_246 = ["for"];
const _hoisted_247 = {
  for: "huey"
};
const _hoisted_248 = {
  class: "role-body"
};
const _hoisted_249 = {
  class: "role-name"
};
const _hoisted_250 = {
  key: 0,
  class: "last-pay-block"
};
const _hoisted_251 = {
  class: "aread-container-block"
};
const _hoisted_252 = {
  key: 0
};
const _hoisted_253 = ["id", "value", "onChange"];
const _hoisted_254 = {
  key: 0,
  class: "now-choice-role-name"
};
const _hoisted_255 = {
  class: "qrcode-box"
};
const _hoisted_256 = {
  id: "qrcode",
  class: "qrcode",
  ref: "qrcodes"
};
const _hoisted_257 = {
  class: "login-box"
};
const _hoisted_258 = {
  class: "header-container"
};
const _hoisted_259 = {
  class: "header-btn"
};
const _hoisted_260 = {
  class: "tabs-list-container"
};
const _hoisted_261 = {
  class: "input-container"
};
const _hoisted_262 = {
  class: "input-body"
};
const _hoisted_263 = {
  class: "input-container"
};
const _hoisted_264 = {
  class: "input-body"
};
const _hoisted_265 = {
  class: "login-btn"
};
const _hoisted_266 = {
  class: "close-icon-popup"
};
const _hoisted_267 = {
  key: 0,
  class: "share-img-box"
};
const _hoisted_268 = ["src"];
const _hoisted_269 = {
  class: "copy-link van-ellipsis"
};
const _hoisted_270 = ["data-clipboard-text"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_van_badge = _resolveComponent("van-badge");
  const _component_van_icon = _resolveComponent("van-icon");
  const _component_van_skeleton_image = _resolveComponent("van-skeleton-image");
  const _component_van_skeleton = _resolveComponent("van-skeleton");
  const _component_van_stepper = _resolveComponent("van-stepper");
  const _component_PointsMall = _resolveComponent("PointsMall");
  const _component_van_button = _resolveComponent("van-button");
  const _component_van_popup = _resolveComponent("van-popup");
  const _component_van_swipe_cell = _resolveComponent("van-swipe-cell");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_ctx.list.publicity_pc ? (_openBlock(), _createElementBlock("div", _hoisted_2, [_createElementVNode("img", {
    src: _ctx.list.publicity_pc,
    alt: ""
  }, null, 8, _hoisted_3)])) : _createCommentVNode("", true), _ctx.list.suspension_button_img && _ctx.showActiveIcon ? (_openBlock(), _createElementBlock("div", _hoisted_4, [_createVNode(_component_van_badge, {
    content: _ctx.activeIconNum(_ctx.list),
    "show-zero": false
  }, {
    default: _withCtx(() => [_createElementVNode("div", {
      class: "active-icon-img",
      onClick: _cache[0] || (_cache[0] = $event => _ctx.getReward())
    }, [_createElementVNode("img", {
      src: _ctx.list.suspension_button_img,
      alt: ""
    }, null, 8, _hoisted_5)])]),
    _: 1
  }, 8, ["content"]), _createVNode(_component_van_icon, {
    name: "clear",
    class: "close-icon",
    onClick: _cache[1] || (_cache[1] = $event => _ctx.showActiveIcon = false)
  })])) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_6, [_createElementVNode("div", _hoisted_7, [_withDirectives(_createElementVNode("div", _hoisted_8, [_createElementVNode("img", {
    src: _ctx.payMethods == 'wap' || _ctx.payMethods == 'mp' ? _ctx.list.publicity_wap : _ctx.list.publicity_pc,
    alt: "",
    class: "top-img-container"
  }, null, 8, _hoisted_9)], 512), [[_vShow, _ctx.list.publicity_wap || _ctx.list.publicity_pc]]), _createElementVNode("div", _hoisted_10, [_createElementVNode("div", _hoisted_11, [_createElementVNode("div", _hoisted_12, [_createElementVNode("div", _hoisted_13, [!_ctx.list.ico ? (_openBlock(), _createBlock(_component_van_skeleton_image, {
    key: 0,
    animate: ""
  })) : _createCommentVNode("", true), _ctx.list.ico ? (_openBlock(), _createElementBlock("img", {
    key: 1,
    src: _ctx.list.ico,
    alt: ""
  }, null, 8, _hoisted_14)) : _createCommentVNode("", true)]), _ctx.loginType == 1 ? (_openBlock(), _createElementBlock("div", {
    key: 0,
    class: "top-info-name",
    onClick: _cache[2] || (_cache[2] = $event => _ctx.loginBtn())
  }, " 您好，请登录 ")) : (_openBlock(), _createElementBlock("div", _hoisted_15, "您好，" + _toDisplayString(_ctx.mobile), 1)), _ctx.loginType != 1 ? (_openBlock(), _createElementBlock("div", {
    key: 2,
    class: "top-info-change",
    onClick: _cache[3] || (_cache[3] = $event => _ctx.loginOut())
  }, " 更换账号 ")) : _createCommentVNode("", true)]), _createElementVNode("div", _hoisted_16, [_createElementVNode("div", {
    onClick: _cache[4] || (_cache[4] = $event => _ctx.showGameRole('show'))
  }, [_createElementVNode("div", _hoisted_17, [_createTextVNode(_toDisplayString(_ctx.chooseGameList.nickname || _ctx.chooseGameList.role_name || "选择角色名称"), 1), _ctx.roleList.is_last_pay == 1 ? (_openBlock(), _createElementBlock("span", _hoisted_18, "最近充值")) : _createCommentVNode("", true)]), _createElementVNode("div", _hoisted_19, [_createElementVNode("span", null, "区服： " + _toDisplayString(_ctx.chooseGameList.dist_name || _ctx.chooseGameList.server_name || "选择游戏区组"), 1), _ctx.chooseGameList.score ? (_openBlock(), _createElementBlock("span", _hoisted_20, "综合战力： " + _toDisplayString(_ctx.chooseGameList.score || 0), 1)) : _createCommentVNode("", true)])]), _createElementVNode("div", {
    class: "bot-info-change",
    onClick: _cache[5] || (_cache[5] = $event => _ctx.showGameRole('show'))
  }, [_cache[65] || (_cache[65] = _createTextVNode(" 切换角色")), _createVNode(_component_van_icon, {
    name: "arrow"
  })])])])]), _createElementVNode("div", _hoisted_21, [_createElementVNode("div", _hoisted_22, "当前积分:" + _toDisplayString(_ctx.pointsNum || 0), 1), _createElementVNode("div", _hoisted_23, [_createElementVNode("span", {
    onClick: _cache[6] || (_cache[6] = $event => _ctx.goExchangePage())
  }, "兑换记录"), _createElementVNode("span", {
    onClick: _cache[7] || (_cache[7] = $event => _ctx.goPointsDetail())
  }, "积分明细")])])]), _createElementVNode("div", {
    class: _normalizeClass(["h5-top-choice", [!_ctx.mobile ? 'no-login' : '']])
  }, [_createElementVNode("div", {
    class: _normalizeClass(["top-choice", [_ctx.showCashCoupon ? 'choice-award' : '']]),
    onClick: _cache[8] || (_cache[8] = $event => _ctx.showCashCoupon = true)
  }, [_cache[66] || (_cache[66] = _createTextVNode(" 游戏充值 ")), _createElementVNode("div", {
    class: _normalizeClass(["bot-line", [_ctx.showCashCoupon ? 'long-line-ani' : '']])
  }, null, 2)], 2), _createElementVNode("div", {
    class: _normalizeClass(["top-choice", [!_ctx.showCashCoupon ? 'choice-award' : '']]),
    onClick: _cache[9] || (_cache[9] = $event => _ctx.goJfMallPage())
  }, [_cache[67] || (_cache[67] = _createTextVNode(" 积分商城 ")), _createElementVNode("div", {
    class: _normalizeClass(["bot-line", [!_ctx.showCashCoupon ? 'long-line-ani' : '']])
  }, null, 2)], 2)], 2), _ctx.showCashCoupon ? (_openBlock(), _createElementBlock("div", _hoisted_24, [!_ctx.list.goods_alias ? (_openBlock(), _createElementBlock("div", _hoisted_25, [(_openBlock(), _createElementBlock(_Fragment, null, _renderList(3, item => {
    return _createVNode(_component_van_skeleton, {
      key: item
    }, {
      template: _withCtx(() => _cache[68] || (_cache[68] = [_createElementVNode("div", {
        class: "skeleton-container-list"
      }, [_createElementVNode("div", {
        class: "skeleton-item"
      }), _createElementVNode("div", {
        class: "skeleton-item"
      }), _createElementVNode("div", {
        class: "skeleton-item"
      })], -1)])),
      _: 2
    }, 1024);
  }), 64))])) : _createCommentVNode("", true), _ctx.list.goods_alias ? (_openBlock(), _createElementBlock("div", _hoisted_26, [_createElementVNode("div", _hoisted_27, [_ctx.list.category_related_game && _ctx.list.category_related_game.length > 0 ? (_openBlock(), _createElementBlock("div", _hoisted_28, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.list.category_related_game, (item, index) => {
    return _openBlock(), _createElementBlock("div", {
      class: "h5-other-list",
      key: item.id
    }, [item.is_top === 1 || item.is_top === '1' ? (_openBlock(), _createElementBlock("div", _hoisted_29, [item.game_pay_official_prop.length > 0 ? (_openBlock(), _createElementBlock("div", _hoisted_30, [_cache[69] || (_cache[69] = _createElementVNode("span", {
      class: "left-line-bgc-img"
    }, null, -1)), _createElementVNode("span", {
      class: _normalizeClass(["left-title", [item.is_highlight === 1 && item.is_highlight === '1' ? 'high-light-color' : '']])
    }, _toDisplayString(item.category_official.name), 3)])) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_31, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.game_pay_official_prop, (subItem, subIndex) => {
      return _openBlock(), _createElementBlock("div", {
        class: "pay-block",
        key: subItem.id
      }, [_createElementVNode("div", {
        class: _normalizeClass(["game-pack", [_ctx.choiceItem.id == subItem.id ? 'show-pack-icon' : '']]),
        onClick: $event => _ctx.choicePay(subItem, index, 2, subIndex)
      }, [subItem.tag_img ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: _normalizeClass(["discount-icon", [(subItem.interflow_stock == subItem.quantity || subItem.game_stock == subItem.quantity) && subItem.quantity >= 0 ? ' sale-out' : '']])
      }, [_createElementVNode("img", {
        src: subItem.tag_img,
        alt: "折扣图片"
      }, null, 8, _hoisted_33)], 2)) : _createCommentVNode("", true), _createElementVNode("div", {
        class: _normalizeClass(["tips-list", [(subItem.interflow_stock == subItem.quantity || subItem.game_stock == subItem.quantity) && subItem.quantity >= 0 ? ' sale-out' : '']])
      }, [(subItem.limit_type == 1 || subItem.limit_type == 2 || subItem.limit_type == 3) && subItem.limit_shelve == 0 ? (_openBlock(), _createElementBlock("div", _hoisted_34, [_cache[70] || (_cache[70] = _createTextVNode(" 每")), subItem.limit_type == 1 ? (_openBlock(), _createElementBlock("span", _hoisted_35, "天")) : _createCommentVNode("", true), subItem.limit_type == 2 ? (_openBlock(), _createElementBlock("span", _hoisted_36, "周")) : _createCommentVNode("", true), subItem.limit_type == 3 ? (_openBlock(), _createElementBlock("span", _hoisted_37, "月")) : _createCommentVNode("", true), _createTextVNode("限购" + _toDisplayString(subItem.interflow_stock || subItem.game_stock) + "/" + _toDisplayString(subItem.quantity), 1)])) : _createCommentVNode("", true), (subItem.limit_type == 1 || subItem.limit_type == 2 || subItem.limit_type == 3) && subItem.limit_shelve > 0 ? (_openBlock(), _createElementBlock("div", _hoisted_38, " 限购" + _toDisplayString(subItem.interflow_stock || subItem.game_stock) + "/" + _toDisplayString(subItem.quantity), 1)) : _createCommentVNode("", true), subItem.limit_type == 5 ? (_openBlock(), _createElementBlock("div", {
        key: 2,
        class: _normalizeClass(["tips-title", [subItem.is_highlight === 1 && subItem.is_highlight === '1' ? 'high-light-color' : '']])
      }, [subItem.is_limited_time != 1 ? (_openBlock(), _createElementBlock("span", _hoisted_39, "永久")) : _createCommentVNode("", true), _cache[71] || (_cache[71] = _createTextVNode("限购")), Number(subItem.quantity) >= 0 ? (_openBlock(), _createElementBlock("span", _hoisted_40, _toDisplayString(subItem.interflow_stock || subItem.game_stock) + "/" + _toDisplayString(subItem.quantity), 1)) : _createCommentVNode("", true)], 2)) : _createCommentVNode("", true), _cache[72] || (_cache[72] = _createElementVNode("div", {
        class: "bot-icon"
      }, null, -1))], 2), _createElementVNode("div", _hoisted_41, [(subItem.interflow_stock == subItem.quantity || subItem.game_stock == subItem.quantity) && subItem.quantity >= 0 ? (_openBlock(), _createElementBlock("div", _hoisted_42)) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_43, [_createElementVNode("img", {
        class: _normalizeClass([(subItem.interflow_stock == subItem.quantity || subItem.game_stock == subItem.quantity) && subItem.quantity >= 0 ? ' sale-out' : '']),
        src: subItem.image_url,
        alt: ""
      }, null, 10, _hoisted_44)]), _createElementVNode("div", _hoisted_45, [subItem.is_limited_time == 1 ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: "limited-container limited-tips5",
        style: _normalizeStyle(subItem.bottom_tag_img ? {
          backgroundImage: `url(${subItem.bottom_tag_img})`
        } : {})
      }, null, 4)) : _createCommentVNode("", true)])]), subItem.vice_name ? (_openBlock(), _createElementBlock("div", {
        key: 1,
        class: "pack-title new-pack-title",
        innerHTML: subItem.vice_name
      }, null, 8, _hoisted_46)) : (_openBlock(), _createElementBlock("div", {
        key: 2,
        class: _normalizeClass(["pack-title new-pack-title van-ellipsis", [subItem.is_highlight === 1 && subItem.is_highlight === '1' ? 'high-light-color' : '']])
      }, _toDisplayString(subItem.name), 3)), _createElementVNode("div", {
        class: _normalizeClass([subItem.price == 0 ? 'pack-price-container-full' : ''])
      }, [_createElementVNode("div", {
        class: _normalizeClass(["pack-price-container", subItem.price == 0 ? 'pack-price-container-mar-bot' : ''])
      }, [_createElementVNode("div", _hoisted_47, [_cache[73] || (_cache[73] = _createElementVNode("span", null, "￥", -1)), _createTextVNode(_toDisplayString(subItem.price), 1)]), _createElementVNode("div", {
        class: "buy-right-now",
        onClick: _withModifiers($event => _ctx.buyNow(subItem, index, 2, subIndex), ["stop"])
      }, " 立即购买 ", 8, _hoisted_48)], 2)], 2), subItem.cart_num == 0 && _ctx.isGwc && subItem.price > 0 ? (_openBlock(), _createElementBlock("div", {
        key: 3,
        class: "pack-gwc",
        onClick: _withModifiers($event => _ctx.addToCart('dj', index, subIndex), ["stop"])
      }, _cache[74] || (_cache[74] = [_createElementVNode("div", {
        class: "gwc-img"
      }, null, -1), _createElementVNode("data", {
        value: "加入购物车"
      }, "加入购物车", -1)]), 8, _hoisted_49)) : _createCommentVNode("", true), subItem.cart_num != 0 && _ctx.isGwc && subItem.price > 0 ? (_openBlock(), _createElementBlock("div", {
        key: 4,
        onClick: _cache[10] || (_cache[10] = _withModifiers(() => {}, ["stop"])),
        class: "pack-gwc"
      }, [_createVNode(_component_van_stepper, {
        modelValue: subItem.cart_num,
        "onUpdate:modelValue": $event => subItem.cart_num = $event,
        min: "0",
        max: _ctx.canBuyNum(subItem),
        "default-value": "0",
        "disable-input": true,
        onOverlimit: _ctx.overlimit,
        onChange: _ctx.stepperChange
      }, null, 8, ["modelValue", "onUpdate:modelValue", "max", "onOverlimit", "onChange"])])) : _createCommentVNode("", true)], 10, _hoisted_32)]);
    }), 128))])])) : _createCommentVNode("", true)]);
  }), 128))])) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_50, [_createElementVNode("div", _hoisted_51, [_cache[75] || (_cache[75] = _createElementVNode("span", {
    class: "left-line-bgc"
  }, null, -1)), _createElementVNode("span", _hoisted_52, _toDisplayString(_ctx.list.goods_alias), 1)]), _createElementVNode("div", _hoisted_53, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.list.product, (subItem, subIndex) => {
    return _openBlock(), _createElementBlock("div", {
      class: "pay-block",
      key: subItem.id
    }, [_createElementVNode("div", {
      class: _normalizeClass(["game-pack", [_ctx.choiceItem.id == subItem.id ? 'show-pack-icon' : '']]),
      onClick: $event => _ctx.choicePay(subItem, subIndex, 1)
    }, [subItem.bonus_mark_img || subItem.points_mark_img || subItem.rebate_mark_img && subItem.rebate_num != 0 ? (_openBlock(), _createElementBlock("div", _hoisted_55, [_createElementVNode("img", {
      src: subItem.bonus_mark_img || subItem.points_mark_img || subItem.rebate_mark_img,
      alt: "折扣图片"
    }, null, 8, _hoisted_56)])) : _createCommentVNode("", true), _createElementVNode("div", {
      class: _normalizeClass(["top-pack-img new-pack-img cash-coupon-img", _ctx.list.goods_ico ? '' : 'top-pack-img-sec'])
    }, [_createElementVNode("div", _hoisted_57, [_createElementVNode("div", _hoisted_58, [_createElementVNode("img", {
      src: subItem.img,
      alt: "商品主图"
    }, null, 8, _hoisted_59)]), _ctx.list.goods_ico ? (_openBlock(), _createElementBlock("div", _hoisted_60, [_ctx.productOtherPrice(subItem) > 0 ? (_openBlock(), _createElementBlock("div", _hoisted_61, " + ")) : _createCommentVNode("", true), _createElementVNode("div", null, [_createElementVNode("div", _hoisted_62, [_createElementVNode("img", {
      src: _ctx.list.goods_ico,
      alt: ""
    }, null, 8, _hoisted_63), _createElementVNode("span", null, _toDisplayString(subItem.bonus_price), 1)]), _ctx.productOtherPrice(subItem) > 0 ? (_openBlock(), _createElementBlock("div", _hoisted_64, [_createElementVNode("img", {
      src: _ctx.list.goods_ico,
      alt: ""
    }, null, 8, _hoisted_65), _createElementVNode("span", null, _toDisplayString(_ctx.productOtherPrice(subItem)), 1)])) : _createCommentVNode("", true)])])) : _createCommentVNode("", true)])], 2), _createElementVNode("div", _hoisted_66, _toDisplayString(subItem.name), 1), _createElementVNode("div", _hoisted_67, [_createElementVNode("div", _hoisted_68, [_cache[76] || (_cache[76] = _createElementVNode("span", null, "￥", -1)), _createTextVNode(_toDisplayString(subItem.price), 1)]), _createElementVNode("div", {
      class: "buy-right-now",
      onClick: _withModifiers($event => _ctx.buyNow(subItem, subIndex, 1), ["stop"])
    }, " 立即购买 ", 8, _hoisted_69)]), _createElementVNode("div", _hoisted_70, [subItem.cart_num == 0 && _ctx.isGwc ? (_openBlock(), _createElementBlock("div", {
      key: 0,
      class: "pack-gwc",
      onClick: _withModifiers($event => _ctx.addToCart('dc', subIndex), ["stop"])
    }, _cache[77] || (_cache[77] = [_createElementVNode("div", {
      class: "gwc-img"
    }, null, -1), _createElementVNode("div", {
      value: "加入购物车"
    }, "加入购物车", -1)]), 8, _hoisted_71)) : _createCommentVNode("", true)]), _createElementVNode("div", _hoisted_72, [subItem.cart_num != 0 && _ctx.isGwc ? (_openBlock(), _createElementBlock("div", {
      key: 0,
      class: "pack-gwc subItem",
      onClick: _withModifiers($event => _ctx.storeInfo(subItem.img, $event), ["stop"])
    }, [_createVNode(_component_van_stepper, {
      class: "subItem",
      onOverlimit: _ctx.overlimit,
      modelValue: subItem.cart_num,
      "onUpdate:modelValue": $event => subItem.cart_num = $event,
      min: "0",
      max: "99",
      onPlus: _ctx.addPlus,
      "default-value": "0",
      "disable-input": true,
      onChange: _ctx.stepperChange
    }, null, 8, ["onOverlimit", "modelValue", "onUpdate:modelValue", "onPlus", "onChange"])], 8, _hoisted_73)) : _createCommentVNode("", true)])], 10, _hoisted_54)]);
  }), 128))]), _createElementVNode("div", _hoisted_74, [_cache[78] || (_cache[78] = _createElementVNode("div", {
    class: "ruler-title"
  }, "充值说明", -1)), _ctx.list.activity_detail ? (_openBlock(), _createElementBlock("div", {
    key: 0,
    class: "tips",
    innerHTML: _ctx.list.activity_detail
  }, null, 8, _hoisted_75)) : _createCommentVNode("", true), _ctx.list.rebate_detail ? (_openBlock(), _createElementBlock("div", {
    key: 1,
    class: "tips",
    innerHTML: _ctx.list.rebate_detail
  }, null, 8, _hoisted_76)) : _createCommentVNode("", true), _createElementVNode("div", {
    class: "tips",
    innerHTML: _ctx.list.product_detail
  }, null, 8, _hoisted_77)])]), _ctx.list.category_related_game && _ctx.list.category_related_game.length > 0 ? (_openBlock(), _createElementBlock("div", _hoisted_78, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.list.category_related_game, (item, index) => {
    return _openBlock(), _createElementBlock("div", {
      class: "h5-other-list",
      key: item.id
    }, [item.is_top === 2 || item.is_top === '2' ? (_openBlock(), _createElementBlock("div", _hoisted_79, [item.game_pay_official_prop.length > 0 ? (_openBlock(), _createElementBlock("div", _hoisted_80, [_cache[79] || (_cache[79] = _createElementVNode("span", {
      class: "left-line-bgc"
    }, null, -1)), _createElementVNode("span", _hoisted_81, _toDisplayString(item.category_official.name), 1)])) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_82, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.game_pay_official_prop, (subItem, subIndex) => {
      return _openBlock(), _createElementBlock("div", {
        class: "pay-block",
        key: subItem.id
      }, [_createElementVNode("div", {
        class: _normalizeClass(["game-pack", [_ctx.choiceItem.id == subItem.id ? 'show-pack-icon' : '']]),
        onClick: $event => _ctx.choicePay(subItem, index, 2, subIndex)
      }, [subItem.tag_img ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: _normalizeClass(["discount-icon", [(subItem.interflow_stock == subItem.quantity || subItem.game_stock == subItem.quantity) && subItem.quantity >= 0 ? ' sale-out' : '']])
      }, [_createElementVNode("img", {
        src: subItem.tag_img,
        alt: "折扣图片"
      }, null, 8, _hoisted_84)], 2)) : _createCommentVNode("", true), _createElementVNode("div", {
        class: _normalizeClass(["tips-list", [(subItem.interflow_stock == subItem.quantity || subItem.game_stock == subItem.quantity) && subItem.quantity >= 0 ? ' sale-out' : '']])
      }, [(subItem.limit_type == 1 || subItem.limit_type == 2 || subItem.limit_type == 3) && subItem.limit_shelve == 0 ? (_openBlock(), _createElementBlock("div", _hoisted_85, [_cache[80] || (_cache[80] = _createTextVNode(" 每")), subItem.limit_type == 1 ? (_openBlock(), _createElementBlock("span", _hoisted_86, "天")) : _createCommentVNode("", true), subItem.limit_type == 2 ? (_openBlock(), _createElementBlock("span", _hoisted_87, "周")) : _createCommentVNode("", true), subItem.limit_type == 3 ? (_openBlock(), _createElementBlock("span", _hoisted_88, "月")) : _createCommentVNode("", true), _createTextVNode("限购" + _toDisplayString(subItem.interflow_stock || subItem.game_stock) + "/" + _toDisplayString(subItem.quantity), 1)])) : _createCommentVNode("", true), (subItem.limit_type == 1 || subItem.limit_type == 2 || subItem.limit_type == 3) && subItem.limit_shelve > 0 ? (_openBlock(), _createElementBlock("div", _hoisted_89, " 限购" + _toDisplayString(subItem.interflow_stock || subItem.game_stock) + "/" + _toDisplayString(subItem.quantity), 1)) : _createCommentVNode("", true), subItem.limit_type == 5 ? (_openBlock(), _createElementBlock("div", _hoisted_90, [subItem.is_limited_time != 1 ? (_openBlock(), _createElementBlock("span", _hoisted_91, "永久")) : _createCommentVNode("", true), _cache[81] || (_cache[81] = _createTextVNode("限购")), Number(subItem.quantity) >= 0 ? (_openBlock(), _createElementBlock("span", _hoisted_92, _toDisplayString(subItem.interflow_stock || subItem.game_stock) + "/" + _toDisplayString(subItem.quantity), 1)) : _createCommentVNode("", true)])) : _createCommentVNode("", true), _cache[82] || (_cache[82] = _createElementVNode("div", {
        class: "bot-icon"
      }, null, -1))], 2), _createElementVNode("div", _hoisted_93, [(subItem.interflow_stock == subItem.quantity || subItem.game_stock == subItem.quantity) == subItem.quantity && subItem.quantity >= 0 ? (_openBlock(), _createElementBlock("div", _hoisted_94)) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_95, [_createElementVNode("img", {
        class: _normalizeClass([(subItem.interflow_stock == subItem.quantity || subItem.game_stock == subItem.quantity) == subItem.quantity && subItem.quantity >= 0 ? ' sale-out' : '']),
        src: subItem.image_url,
        alt: ""
      }, null, 10, _hoisted_96)]), _createElementVNode("div", _hoisted_97, [subItem.is_limited_time == 1 ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: "limited-container limited-tips5",
        style: _normalizeStyle(subItem.bottom_tag_img ? {
          backgroundImage: `url(${subItem.bottom_tag_img})`
        } : {})
      }, null, 4)) : _createCommentVNode("", true)])]), subItem.vice_name ? (_openBlock(), _createElementBlock("div", {
        key: 1,
        class: "pack-title new-pack-title",
        innerHTML: subItem.vice_name
      }, null, 8, _hoisted_98)) : (_openBlock(), _createElementBlock("div", {
        key: 2,
        class: _normalizeClass(["pack-title new-pack-title van-ellipsis", [subItem.is_highlight === 1 && subItem.is_highlight === '1' ? 'high-light-color' : '']])
      }, _toDisplayString(subItem.name), 3)), _createElementVNode("div", {
        class: _normalizeClass([subItem.price == 0 ? 'pack-price-container-full' : ''])
      }, [_createElementVNode("div", {
        class: _normalizeClass(["pack-price-container", subItem.price == 0 ? 'pack-price-container-mar-bot' : ''])
      }, [_createElementVNode("div", _hoisted_99, [_cache[83] || (_cache[83] = _createElementVNode("span", null, "￥", -1)), _createTextVNode(_toDisplayString(subItem.price), 1)]), _createElementVNode("div", {
        class: "buy-right-now",
        onClick: _withModifiers($event => _ctx.buyNow(subItem, index, 2, subIndex), ["stop"])
      }, " 立即购买 ", 8, _hoisted_100)], 2)], 2), subItem.cart_num == 0 && _ctx.isGwc && subItem.price > 0 ? (_openBlock(), _createElementBlock("div", {
        key: 3,
        class: "pack-gwc",
        onClick: _withModifiers($event => _ctx.addToCart('dj', index, subIndex), ["stop"])
      }, _cache[84] || (_cache[84] = [_createElementVNode("div", {
        class: "gwc-img"
      }, null, -1), _createElementVNode("data", {
        value: "加入购物车"
      }, "加入购物车", -1)]), 8, _hoisted_101)) : _createCommentVNode("", true), subItem.cart_num != 0 && _ctx.isGwc && subItem.price > 0 ? (_openBlock(), _createElementBlock("div", {
        key: 4,
        onClick: _cache[11] || (_cache[11] = _withModifiers(() => {}, ["stop"])),
        class: "pack-gwc"
      }, [_createVNode(_component_van_stepper, {
        modelValue: subItem.cart_num,
        "onUpdate:modelValue": $event => subItem.cart_num = $event,
        min: "0",
        max: _ctx.canBuyNum(subItem),
        "default-value": "0",
        "disable-input": true,
        onOverlimit: _ctx.overlimit,
        onChange: _ctx.stepperChange
      }, null, 8, ["modelValue", "onUpdate:modelValue", "max", "onOverlimit", "onChange"])])) : _createCommentVNode("", true)], 10, _hoisted_83)]);
    }), 128))])])) : _createCommentVNode("", true)]);
  }), 128))])) : _createCommentVNode("", true)]), _ctx.rechargeCategoryList.length > 0 ? (_openBlock(), _createElementBlock("div", _hoisted_102, [_cache[89] || (_cache[89] = _createElementVNode("div", {
    class: "left-line"
  }, [_createElementVNode("span", {
    class: "left-line-bgc"
  }), _createElementVNode("span", {
    class: "left-title"
  }, " 充值活动 ")], -1)), _createElementVNode("div", _hoisted_103, [_createElementVNode("div", _hoisted_104, [_createElementVNode("div", {
    class: _normalizeClass(["recharge-list", [_ctx.progressWidth == _ctx.rechargeBodyWidth ? 'recharge-list-sec' : '']])
  }, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.rechargeCategoryList, (item, index) => {
    return _openBlock(), _createElementBlock("div", {
      class: "recharge-block-list",
      key: index
    }, [_createElementVNode("div", {
      class: _normalizeClass([[_ctx.rechargePhase == index && !item.is_rewards ? 'recharge-block-sec' : 'recharge-block'], "recharge-public"])
    }, [_createElementVNode("div", {
      class: _normalizeClass(["top-title", [!item.is_rewards ? '' : 'top-title-sec']])
    }, " 累计" + _toDisplayString(item.price) + "元 ", 3), _createElementVNode("div", _hoisted_105, [_createElementVNode("div", _hoisted_106, [_createElementVNode("img", {
      src: item.img || `https://download4.qcplay.com/qcgame-admin/ug1Q1ZRFe6i1Ef7ANtqtB9Bs43HK7cxyITNtUkwH.png`,
      alt: ""
    }, null, 8, _hoisted_107)]), _createElementVNode("div", {
      class: _normalizeClass(["bot-detail", [!item.is_rewards ? '' : 'bot-detail-sec']])
    }, _toDisplayString(item.name), 3)]), _ctx.rechargePhase == index && !item.is_rewards ? (_openBlock(), _createElementBlock("div", _hoisted_108, " 下阶段 ")) : _createCommentVNode("", true), item.is_rewards ? (_openBlock(), _createElementBlock("div", _hoisted_109, [_cache[85] || (_cache[85] = _createElementVNode("div", {
      class: "over-top-title"
    }, "已获得", -1)), _cache[86] || (_cache[86] = _createElementVNode("div", {
      class: "over-mid-img"
    }, [_createElementVNode("img", {
      src: "https://download4.qcplay.com/qcgame-api/3d7lL3V9x9MrwKANuMbkhzbSrka0rAXC7FU4wOgd.png",
      alt: ""
    })], -1)), _createElementVNode("div", _hoisted_110, _toDisplayString(item.name), 1)])) : _createCommentVNode("", true)], 2)]);
  }), 128))], 2), _createElementVNode("div", _hoisted_111, [_createElementVNode("div", {
    class: "cumulative-recharge-list",
    style: _normalizeStyle({
      width: _ctx.progressWidth + 'px'
    })
  }, [_createElementVNode("div", {
    class: "begin",
    id: "h-begin-icon",
    style: _normalizeStyle({
      width: _ctx.hLongW + 'px'
    })
  }, null, 4), _createElementVNode("div", {
    class: "begging-line",
    style: _normalizeStyle({
      left: _ctx.dottedLeft + 'px',
      width: _ctx.dottedW + 'px'
    })
  }, [_createElementVNode("div", {
    class: "line",
    style: _normalizeStyle({
      width: _ctx.dottedW + 'px',
      'border-top-width': _ctx.dottedW > 0 ? '2px' : 0
    })
  }, null, 4)], 4), _cache[87] || (_cache[87] = _createElementVNode("div", {
    class: "recharge-bgc-line"
  }, null, -1)), _createElementVNode("div", {
    class: _normalizeClass(["recharge-block-icon-list", [_ctx.progressWidth == _ctx.rechargeBodyWidth ? 'recharge-block-icon-list-sec' : '']]),
    id: "hrecharge-icon-list"
  }, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.rechargeCategoryList, (item, index) => {
    return _openBlock(), _createElementBlock("div", {
      class: "recharge-icon-body",
      key: index
    }, [_createElementVNode("div", {
      class: "recharge-icon-img",
      id: `hrecharge-icon-${index}`
    }, [item.is_rewards != 1 && _ctx.rechargePhase != index ? (_openBlock(), _createElementBlock("div", _hoisted_113)) : _createCommentVNode("", true), item.is_rewards == 1 ? (_openBlock(), _createElementBlock("div", _hoisted_114)) : _createCommentVNode("", true), item.is_rewards != 1 && _ctx.rechargePhase == index ? (_openBlock(), _createElementBlock("div", _hoisted_115)) : _createCommentVNode("", true)], 8, _hoisted_112)]);
  }), 128))], 2)], 4)])]), _ctx.rechargeCategoryList.length > 0 ? (_openBlock(), _createElementBlock("div", _hoisted_116, [_ctx.rechargeCategoryList[_ctx.rechargePhase].is_rewards != 1 ? (_openBlock(), _createElementBlock("div", _hoisted_117, [_createTextVNode(" 本次活动已充值" + _toDisplayString(_ctx.amountPaid) + "元，再充值", 1), _createElementVNode("span", null, _toDisplayString(_ctx.distanceAmount) + "元", 1), _cache[88] || (_cache[88] = _createTextVNode("即可领取下阶段奖励 "))])) : (_openBlock(), _createElementBlock("div", _hoisted_118, "当前累充活动所有阶段已全部完成"))])) : _createCommentVNode("", true), _createElementVNode("div", {
    class: "bot-tips-detail",
    innerHTML: _ctx.rechargeTitle
  }, null, 8, _hoisted_119)])])) : _createCommentVNode("", true)])) : _createCommentVNode("", true)])) : (_openBlock(), _createElementBlock("div", _hoisted_120, [_createVNode(_component_PointsMall, {
    ref: "pointsMallContainer",
    gameId: _ctx.gameId,
    role_id: _ctx.chooseGameList.role_id ? _ctx.chooseGameList.role_id : '',
    onShowGameRole: _cache[12] || (_cache[12] = $event => _ctx.showGameRole('show')),
    onChangeCashCoupon: _cache[13] || (_cache[13] = $event => _ctx.showCashCoupon = true)
  }, null, 8, ["gameId", "role_id"])])), _ctx.showCashCoupon ? (_openBlock(), _createElementBlock("div", _hoisted_121, [_cache[90] || (_cache[90] = _createElementVNode("div", {
    class: "ruler-title"
  }, "充值说明", -1)), _ctx.list.ad_datail ? (_openBlock(), _createElementBlock("div", {
    key: 0,
    class: "tips",
    innerHTML: _ctx.list.ad_datail
  }, null, 8, _hoisted_122)) : _createCommentVNode("", true), _ctx.list.activity_detail ? (_openBlock(), _createElementBlock("div", {
    key: 1,
    class: "tips",
    innerHTML: _ctx.list.activity_detail
  }, null, 8, _hoisted_123)) : _createCommentVNode("", true), _ctx.list.rebate_detail ? (_openBlock(), _createElementBlock("div", {
    key: 2,
    class: "tips",
    innerHTML: _ctx.list.rebate_detail
  }, null, 8, _hoisted_124)) : _createCommentVNode("", true), _createElementVNode("div", {
    class: "tips",
    innerHTML: _ctx.list.product_detail
  }, null, 8, _hoisted_125)])) : _createCommentVNode("", true), _ctx.showCashCoupon && (_ctx.choiceItem.price > 0 || _ctx.gwcNum > 0) && _ctx.mobile ? (_openBlock(), _createElementBlock("div", _hoisted_126, [_ctx.isGwc ? (_openBlock(), _createElementBlock("div", {
    key: 0,
    class: "gwc-btn",
    onClick: _cache[14] || (_cache[14] = $event => _ctx.openGwc())
  }, [_createElementVNode("div", _hoisted_127, [_createElementVNode("div", _hoisted_128, _toDisplayString(_ctx.gwcNum), 1)]), _cache[91] || (_cache[91] = _createElementVNode("div", {
    class: "gwc-text"
  }, "购物车", -1))])) : _createCommentVNode("", true), _createElementVNode("div", {
    class: "total",
    onClick: _cache[15] || (_cache[15] = $event => _ctx.isGwc ? _ctx.openGwc() : '')
  }, [_cache[93] || (_cache[93] = _createTextVNode(" 合计：")), _createElementVNode("span", null, [_cache[92] || (_cache[92] = _createElementVNode("span", {
    class: "price-icon"
  }, "￥ ", -1)), _createTextVNode(" " + _toDisplayString(_ctx.totalPrice > 0 ? _ctx.totalPrice : _ctx.choiceItem.price || 0), 1)])]), _createElementVNode("div", {
    class: "pay-btn",
    onClick: _cache[16] || (_cache[16] = $event => _ctx.isGwc ? _ctx.openGwc() : _ctx.showH5Pay())
  }, " 立即支付 ")], 512)) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_129, [_createElementVNode("div", _hoisted_130, [_createVNode(_component_van_button, {
    onClick: _cache[17] || (_cache[17] = $event => _ctx.setPay())
  }, {
    default: _withCtx(() => _cache[94] || (_cache[94] = [_createTextVNode("立即支付")])),
    _: 1
  })]), _createElementVNode("div", _hoisted_131, [_cache[95] || (_cache[95] = _createTextVNode(" 温馨提示：请您知悉，点击立即支付即视为您同意")), _cache[96] || (_cache[96] = _createElementVNode("br", null, null, -1)), _createElementVNode("span", {
    onClick: _cache[18] || (_cache[18] = $event => _ctx.goRuler())
  }, "《青瓷游戏用户服务协议》")])])]), _cache[154] || (_cache[154] = _createElementVNode("div", {
    id: "aliPayBtn"
  }, null, -1)), _createVNode(_component_van_popup, {
    show: _ctx.showH5PayPopup,
    "onUpdate:show": _cache[33] || (_cache[33] = $event => _ctx.showH5PayPopup = $event),
    position: "bottom",
    onClose: _ctx.closeResultSheet
  }, {
    default: _withCtx(() => [_createElementVNode("div", _hoisted_132, [_ctx.showType ? (_openBlock(), _createElementBlock("div", {
      key: 0,
      class: "show-bot-popup",
      onClick: _cache[19] || (_cache[19] = $event => _ctx.showType = false)
    })) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_133, [_createElementVNode("div", _hoisted_134, [_cache[97] || (_cache[97] = _createElementVNode("div", {
      class: "choice-title"
    }, "所选商品", -1)), _createVNode(_component_van_icon, {
      name: "cross",
      size: "20",
      onClick: _cache[20] || (_cache[20] = $event => _ctx.showH5PayPopup = false)
    })]), _createElementVNode("div", _hoisted_135, [_createElementVNode("div", _hoisted_136, [_createElementVNode("span", null, _toDisplayString(_ctx.chooseGameList.nickname || _ctx.chooseGameList.server_name), 1), _ctx.roleList.is_last_pay == 1 ? (_openBlock(), _createElementBlock("span", _hoisted_137, "最近充值")) : _createCommentVNode("", true)]), _createElementVNode("div", _hoisted_138, [_createElementVNode("span", null, "区服: " + _toDisplayString(_ctx.chooseGameList.dist_name || _ctx.chooseGameList.role_name), 1), _ctx.chooseGameList.score ? (_openBlock(), _createElementBlock("span", _hoisted_139, "综合战力 " + _toDisplayString(_ctx.chooseGameList.score || 0), 1)) : _createCommentVNode("", true)])]), _createElementVNode("div", _hoisted_140, [_createElementVNode("div", _hoisted_141, [_createElementVNode("div", _hoisted_142, [_createElementVNode("div", _hoisted_143, [_createElementVNode("img", {
      src: _ctx.choiceItem.img || _ctx.choiceItem.image_url,
      alt: ""
    }, null, 8, _hoisted_144)])]), _createElementVNode("div", _hoisted_145, [_createElementVNode("div", _hoisted_146, [_createElementVNode("span", _hoisted_147, _toDisplayString(_ctx.choiceItem.name), 1)]), _ctx.choiceItem.rebate_gift_price && _ctx.choiceItem.rebate_num > 0 ? (_openBlock(), _createElementBlock("div", _hoisted_148, [_cache[98] || (_cache[98] = _createElementVNode("div", {
      class: "detail-left detail-left-thr"
    }, "返", -1)), _createElementVNode("div", _hoisted_149, [_ctx.choiceItem.rebate_num > 0 ? (_openBlock(), _createElementBlock("span", _hoisted_150, _toDisplayString(_ctx.choiceItem.rebate_gift_price) + _toDisplayString(_ctx.list.goods_alias) + "(剩余" + _toDisplayString(_ctx.choiceItem.rebate_num) + "次)", 1)) : (_openBlock(), _createElementBlock("span", _hoisted_151, _toDisplayString(_ctx.choiceItem.rebate_gift_price) + _toDisplayString(_ctx.list.goods_alias), 1))])])) : _createCommentVNode("", true), _ctx.choiceItem.points_mark_img ? (_openBlock(), _createElementBlock("div", _hoisted_152, [_cache[99] || (_cache[99] = _createElementVNode("div", {
      class: "detail-left detail-left-four"
    }, "首", -1)), _createElementVNode("div", _hoisted_153, [_createElementVNode("span", null, "首充双倍额外积分：" + _toDisplayString(_ctx.choiceItem.price), 1)])])) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_154, [_createElementVNode("span", _hoisted_155, [_cache[100] || (_cache[100] = _createElementVNode("span", {
      class: "price-icon"
    }, "￥", -1)), _createTextVNode(_toDisplayString(_ctx.choiceItem.price), 1)]), _ctx.isGwc ? (_openBlock(), _createElementBlock("span", _hoisted_156, [_createVNode(_component_van_stepper, {
      modelValue: _ctx.buyNowStep,
      "onUpdate:modelValue": _cache[21] || (_cache[21] = $event => _ctx.buyNowStep = $event),
      min: "0",
      onOverlimit: _ctx.overlimit,
      max: _ctx.canBuyNumGwcOne(_ctx.choiceItem),
      "default-value": "0",
      "disable-input": true,
      theme: "round",
      "button-size": "26",
      onChange: _ctx.stepResultSheet
    }, null, 8, ["modelValue", "onOverlimit", "max", "onChange"])])) : _createCommentVNode("", true)])])]), _createElementVNode("div", _hoisted_157, [!_ctx.choiceItem.describe ? (_openBlock(), _createElementBlock("span", _hoisted_158, "【商品内容】")) : _createCommentVNode("", true), _createTextVNode(_toDisplayString(_ctx.choiceItem.describe || _ctx.choiceItem.name), 1)])]), _createElementVNode("div", _hoisted_159, [_createElementVNode("div", _hoisted_160, [_cache[101] || (_cache[101] = _createTextVNode(" 商品合计")), _createElementVNode("span", null, "共计" + _toDisplayString(_ctx.buyNowStep) + "件商品", 1)]), _createElementVNode("div", _hoisted_161, [_cache[102] || (_cache[102] = _createElementVNode("div", {
      class: "detail-left"
    }, "含", -1)), _ctx.channelType == 1 ? (_openBlock(), _createElementBlock("div", _hoisted_162, _toDisplayString(_ctx.choiceItem.bonus_price * _ctx.buyNowStep || _ctx.choiceItem.name) + _toDisplayString(_ctx.list.goods_alias), 1)) : (_openBlock(), _createElementBlock("div", _hoisted_163, _toDisplayString(_ctx.choiceItem.name) + " x " + _toDisplayString(_ctx.buyNowStep), 1))]), _ctx.choiceItem.bonus ? (_openBlock(), _createElementBlock("div", _hoisted_164, [_cache[103] || (_cache[103] = _createElementVNode("div", {
      class: "detail-left"
    }, "赠", -1)), _createElementVNode("div", _hoisted_165, "首充赠礼：" + _toDisplayString(_ctx.choiceItem.bonus), 1)])) : _createCommentVNode("", true), _ctx.choiceItem.rebate_gift_price && _ctx.choiceItem.rebate_num != 0 ? (_openBlock(), _createElementBlock("div", _hoisted_166, [_cache[104] || (_cache[104] = _createElementVNode("div", {
      class: "detail-left detail-left-thr"
    }, "返", -1)), _createElementVNode("div", _hoisted_167, " 充值返利：" + _toDisplayString(_ctx.totalRebateSec) + _toDisplayString(_ctx.list.goods_alias), 1)])) : _createCommentVNode("", true), _ctx.choiceItem.points_mark_img ? (_openBlock(), _createElementBlock("div", _hoisted_168, [_cache[105] || (_cache[105] = _createElementVNode("div", {
      class: "detail-left detail-left-four"
    }, "首", -1)), _createElementVNode("div", _hoisted_169, " 首充双倍额外积分：+" + _toDisplayString(_ctx.choiceItem.price) + "积分 ", 1)])) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_170, [_ctx.channelType === 1 || _ctx.channelType === 2 && (_ctx.choiceItem.send_points === 0 && _ctx.choiceItem.points > 0 || _ctx.choiceItem.send_points > 0 && _ctx.choiceItem.points === 0) ? (_openBlock(), _createElementBlock("div", _hoisted_171, " 积 ")) : _createCommentVNode("", true), _ctx.channelType == 1 ? (_openBlock(), _createElementBlock("div", _hoisted_172, [_ctx.choiceItem.points ? (_openBlock(), _createElementBlock("span", _hoisted_173, "合计：" + _toDisplayString(_ctx.firTopUpFormatter(_ctx.choiceItem.price, _ctx.buyNowStep)) + "积分", 1)) : (_openBlock(), _createElementBlock("span", _hoisted_174, _toDisplayString(_ctx.jfFormatter(_ctx.choiceItem.price, _ctx.buyNowStep)) + "积分", 1))])) : (_openBlock(), _createElementBlock("div", _hoisted_175, [_ctx.choiceItem.send_points && _ctx.choiceItem.send_points > 0 ? (_openBlock(), _createElementBlock("span", _hoisted_176, _toDisplayString(_ctx.choiceItem.send_points) + "积分", 1)) : _createCommentVNode("", true), _ctx.choiceItem.send_points == 0 && _ctx.choiceItem.points > 0 ? (_openBlock(), _createElementBlock("span", _hoisted_177, _toDisplayString(_ctx.jfFormatter(_ctx.choiceItem.points, _ctx.buyNowStep)) + "积分", 1)) : _createCommentVNode("", true)]))])]), _ctx.choiceItem.price > 0 ? (_openBlock(), _createElementBlock("div", _hoisted_178, [_cache[111] || (_cache[111] = _createElementVNode("div", {
      class: "pay-choice-title"
    }, "支付方式", -1)), _createElementVNode("div", {
      class: _normalizeClass(["pay-choice-btn", [_ctx.payType == 'alipay' ? ' choice-pay-type' : '']]),
      onClick: _cache[22] || (_cache[22] = $event => _ctx.changePay('alipay'))
    }, [_cache[106] || (_cache[106] = _createElementVNode("div", {
      class: "alipay"
    }, [_createElementVNode("img", {
      src: _imports_0,
      alt: ""
    })], -1)), _cache[107] || (_cache[107] = _createElementVNode("div", {
      class: "pay-mid-title"
    }, "支付宝支付", -1)), _ctx.showAliPay ? (_openBlock(), _createElementBlock("div", _hoisted_179, "推荐")) : _createCommentVNode("", true)], 2), _createElementVNode("div", {
      class: _normalizeClass(["pay-choice-btn", [_ctx.payType == 'wechat' ? ' choice-pay-type' : '']]),
      onClick: _cache[23] || (_cache[23] = $event => _ctx.changePay('wechat'))
    }, _cache[108] || (_cache[108] = [_createElementVNode("div", {
      class: "wechat"
    }, [_createElementVNode("img", {
      src: _imports_1,
      alt: ""
    })], -1), _createElementVNode("div", {
      class: "pay-mid-title"
    }, "微信支付", -1)]), 2), _createElementVNode("div", {
      class: _normalizeClass(["pay-choice-btn", [_ctx.payType == 'pay_behalf' ? ' choice-pay-type' : '']]),
      onClick: _cache[24] || (_cache[24] = $event => _ctx.changePay('pay_behalf'))
    }, _cache[109] || (_cache[109] = [_createElementVNode("div", {
      class: "wechat"
    }, [_createElementVNode("img", {
      src: _imports_2,
      alt: ""
    })], -1), _createElementVNode("div", {
      class: "pay-mid-title"
    }, "找朋友帮忙付", -1)]), 2), _cache[112] || (_cache[112] = _createElementVNode("div", {
      class: "pay-tips"
    }, " 在进行支付时，由于支付渠道相关规则，可能出现超额提醒、限额提醒、风险提醒等，可切换支付方式后再次尝试 ", -1)), _createElementVNode("div", _hoisted_180, [_cache[110] || (_cache[110] = _createTextVNode(" 温馨提示：请您知悉，点击立即支付即视为您同意")), _createElementVNode("span", {
      onClick: _cache[25] || (_cache[25] = $event => _ctx.goRuler())
    }, "《青瓷游戏用户服务协议》")])])) : _createCommentVNode("", true)]), _createElementVNode("div", _hoisted_181, [_ctx.showType ? (_openBlock(), _createElementBlock("div", _hoisted_182, [_createElementVNode("div", _hoisted_183, [_cache[117] || (_cache[117] = _createElementVNode("div", {
      class: "pay-choice-title"
    }, "支付方式", -1)), _createElementVNode("div", {
      class: _normalizeClass(["pay-choice-btn", [_ctx.payType == 'alipay' ? ' choice-pay-type' : '']]),
      onClick: _cache[26] || (_cache[26] = $event => _ctx.changePay('alipay'))
    }, [_cache[113] || (_cache[113] = _createElementVNode("div", {
      class: "alipay"
    }, [_createElementVNode("img", {
      src: _imports_0,
      alt: ""
    })], -1)), _cache[114] || (_cache[114] = _createElementVNode("div", {
      class: "pay-mid-title"
    }, "支付宝支付", -1)), _ctx.showAliPay ? (_openBlock(), _createElementBlock("div", _hoisted_184, "推荐")) : _createCommentVNode("", true)], 2), _createElementVNode("div", {
      class: _normalizeClass(["pay-choice-btn", [_ctx.payType == 'wechat' ? ' choice-pay-type' : '']]),
      onClick: _cache[27] || (_cache[27] = $event => _ctx.changePay('wechat'))
    }, _cache[115] || (_cache[115] = [_createElementVNode("div", {
      class: "wechat"
    }, [_createElementVNode("img", {
      src: _imports_1,
      alt: ""
    })], -1), _createElementVNode("div", {
      class: "pay-mid-title"
    }, "微信支付", -1)]), 2), _createElementVNode("div", {
      class: _normalizeClass(["pay-choice-btn", [_ctx.payType == 'pay_behalf' ? ' choice-pay-type' : '']]),
      onClick: _cache[28] || (_cache[28] = $event => _ctx.changePay('pay_behalf'))
    }, _cache[116] || (_cache[116] = [_createElementVNode("div", {
      class: "wechat"
    }, [_createElementVNode("img", {
      src: _imports_2,
      alt: ""
    })], -1), _createElementVNode("div", {
      class: "pay-mid-title"
    }, "找朋友帮忙付", -1)]), 2)])])) : _createCommentVNode("", true), _ctx.isGwc ? (_openBlock(), _createElementBlock("div", _hoisted_185, [_createElementVNode("div", {
      class: "gwc-btn",
      onClick: _cache[29] || (_cache[29] = $event => _ctx.openGwc())
    }, [_createElementVNode("div", _hoisted_186, [_createElementVNode("div", _hoisted_187, _toDisplayString(_ctx.gwcNum), 1)]), _cache[118] || (_cache[118] = _createElementVNode("div", {
      class: "gwc-text"
    }, "购物车", -1))]), _ctx.choiceItem.price > 0 ? (_openBlock(), _createElementBlock("div", {
      key: 0,
      class: "add-gwc-btn",
      onClick: _cache[30] || (_cache[30] = $event => _ctx.addToCartSec())
    }, " 加入购物车 ")) : _createCommentVNode("", true), _createElementVNode("div", {
      class: "pay-btn",
      onClick: _cache[31] || (_cache[31] = $event => _ctx.gwcSetPay())
    }, [_cache[120] || (_cache[120] = _createTextVNode(" 立即支付")), _createElementVNode("span", null, [_cache[119] || (_cache[119] = _createElementVNode("span", {
      class: "price-icon"
    }, "￥", -1)), _createTextVNode(_toDisplayString(_ctx.jfFormatter(_ctx.choiceItem.price, _ctx.buyNowStep)), 1)])])])) : (_openBlock(), _createElementBlock("div", _hoisted_188, [_createElementVNode("div", _hoisted_189, [_cache[122] || (_cache[122] = _createTextVNode(" 合计：")), _createElementVNode("span", null, [_cache[121] || (_cache[121] = _createElementVNode("span", {
      class: "price-icon"
    }, "￥", -1)), _createTextVNode(_toDisplayString(_ctx.choiceItem.price), 1)])]), _createElementVNode("div", {
      class: "pay-btn",
      onClick: _cache[32] || (_cache[32] = $event => _ctx.setPay())
    }, "立即支付")]))])])]),
    _: 1
  }, 8, ["show", "onClose"]), _createVNode(_component_van_popup, {
    show: _ctx.showGwcPopup,
    "onUpdate:show": _cache[45] || (_cache[45] = $event => _ctx.showGwcPopup = $event),
    position: "bottom",
    onOpened: _cache[46] || (_cache[46] = $event => _ctx.openGwcList()),
    onClosed: _cache[47] || (_cache[47] = $event => _ctx.closeGwcList())
  }, {
    default: _withCtx(() => [_createElementVNode("div", _hoisted_190, [_ctx.showType ? (_openBlock(), _createElementBlock("div", {
      key: 0,
      class: "show-bot-popup",
      onClick: _cache[34] || (_cache[34] = $event => _ctx.showType = false)
    })) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_191, [_createElementVNode("div", _hoisted_192, [_createElementVNode("div", _hoisted_193, "购物车(" + _toDisplayString(_ctx.gwcNum) + ")", 1), _createVNode(_component_van_icon, {
      name: "cross",
      size: "20",
      onClick: _cache[35] || (_cache[35] = $event => _ctx.showGwcPopup = false)
    })]), _createElementVNode("div", _hoisted_194, [_createElementVNode("div", _hoisted_195, [_createElementVNode("span", null, _toDisplayString(_ctx.chooseGameList.nickname || _ctx.chooseGameList.server_name), 1), _cache[123] || (_cache[123] = _createElementVNode("span", {
      class: "small-text"
    }, "最近充值", -1))]), _createElementVNode("div", _hoisted_196, [_createElementVNode("span", null, "区服: " + _toDisplayString(_ctx.chooseGameList.dist_name || _ctx.chooseGameList.role_name), 1), _createElementVNode("span", null, "综合战力: " + _toDisplayString(_ctx.chooseGameList.score || 0), 1)])]), _createElementVNode("div", _hoisted_197, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.gwcList, (item, index) => {
      return _openBlock(), _createElementBlock("div", {
        key: item.id
      }, [_createVNode(_component_van_swipe_cell, null, {
        right: _withCtx(() => [_createElementVNode("div", {
          class: "delete-btn",
          onClick: $event => _ctx.delGwcList(index)
        }, _cache[127] || (_cache[127] = [_createElementVNode("img", {
          src: _imports_3,
          alt: ""
        }, null, -1)]), 8, _hoisted_215)]),
        default: _withCtx(() => [_createElementVNode("div", _hoisted_198, [_createElementVNode("div", _hoisted_199, [_createElementVNode("div", _hoisted_200, [_createElementVNode("img", {
          src: item.img || item.image_url,
          alt: ""
        }, null, 8, _hoisted_201)])]), _createElementVNode("div", _hoisted_202, [_createElementVNode("div", _hoisted_203, [_createElementVNode("span", _hoisted_204, _toDisplayString(item.name), 1)]), item.rebate_gift_price && item.rebate_num > 0 ? (_openBlock(), _createElementBlock("div", _hoisted_205, [_cache[124] || (_cache[124] = _createElementVNode("div", {
          class: "detail-left detail-left-thr"
        }, "返", -1)), _createElementVNode("div", _hoisted_206, [item.rebate_num > 0 ? (_openBlock(), _createElementBlock("span", _hoisted_207, _toDisplayString(item.rebate_gift_price) + _toDisplayString(_ctx.list.goods_alias) + "(剩余" + _toDisplayString(item.rebate_num) + "次)", 1)) : (_openBlock(), _createElementBlock("span", _hoisted_208, _toDisplayString(item.rebate_gift_price) + _toDisplayString(_ctx.list.goods_alias), 1))])])) : _createCommentVNode("", true), item.points_mark_img ? (_openBlock(), _createElementBlock("div", _hoisted_209, [_cache[125] || (_cache[125] = _createElementVNode("div", {
          class: "detail-left detail-left-four"
        }, "首", -1)), _createElementVNode("div", _hoisted_210, [_createElementVNode("span", null, "首充双倍额外积分：" + _toDisplayString(item.price), 1)])])) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_211, [_createElementVNode("span", _hoisted_212, [_cache[126] || (_cache[126] = _createElementVNode("span", {
          class: "price-icon"
        }, "￥", -1)), _createTextVNode(_toDisplayString(item.price), 1)]), _createElementVNode("span", null, [_createVNode(_component_van_stepper, {
          modelValue: item.cart_num,
          "onUpdate:modelValue": $event => item.cart_num = $event,
          onOverlimit: _ctx.overlimit,
          min: "0",
          max: _ctx.canBuyNumGwcOne(item),
          "default-value": "0",
          "disable-input": true,
          theme: "round",
          "button-size": "26",
          onChange: _ctx.stepperChangeSec
        }, null, 8, ["modelValue", "onUpdate:modelValue", "onOverlimit", "max", "onChange"])])])])]), _createElementVNode("div", _hoisted_213, [!item.describe ? (_openBlock(), _createElementBlock("span", _hoisted_214, "【商品内容】")) : _createCommentVNode("", true), _createTextVNode(_toDisplayString(item.bonus || item.describe || item.name), 1)])]),
        _: 2
      }, 1024)]);
    }), 128))]), _createElementVNode("div", _hoisted_216, [_createElementVNode("div", _hoisted_217, [_cache[128] || (_cache[128] = _createTextVNode(" 商品合计")), _createElementVNode("span", null, "共计" + _toDisplayString(_ctx.gwcNum) + "件商品", 1)]), _createElementVNode("div", _hoisted_218, [_cache[129] || (_cache[129] = _createElementVNode("div", {
      class: "detail-left"
    }, "含", -1)), _createElementVNode("div", _hoisted_219, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.gwcList, item => {
      return _openBlock(), _createElementBlock("span", {
        key: item.id
      }, [item.type == 3 ? (_openBlock(), _createElementBlock("span", _hoisted_220, [_createTextVNode(_toDisplayString(item.name) + " x " + _toDisplayString(item.cart_num), 1), _ctx.totalBonusPrice ? (_openBlock(), _createElementBlock("span", _hoisted_221, "，")) : _createCommentVNode("", true)])) : _createCommentVNode("", true)]);
    }), 128)), _ctx.totalBonusPrice ? (_openBlock(), _createElementBlock("span", _hoisted_222, _toDisplayString(_ctx.totalBonusPrice) + _toDisplayString(_ctx.list.goods_alias), 1)) : _createCommentVNode("", true)])]), _ctx.showBonus && _ctx.sendTotalBonusPrice > 0 ? (_openBlock(), _createElementBlock("div", _hoisted_223, [_cache[130] || (_cache[130] = _createElementVNode("div", {
      class: "detail-left"
    }, "赠", -1)), _createElementVNode("div", _hoisted_224, " 首充赠礼：" + _toDisplayString(_ctx.sendTotalBonusPrice) + _toDisplayString(_ctx.list.goods_alias), 1)])) : _createCommentVNode("", true), _ctx.totalRebatePrice > 0 ? (_openBlock(), _createElementBlock("div", _hoisted_225, [_cache[131] || (_cache[131] = _createElementVNode("div", {
      class: "detail-left detail-left-thr"
    }, "返", -1)), _createElementVNode("div", _hoisted_226, " 充值返利：" + _toDisplayString(_ctx.totalRebatePrice) + _toDisplayString(_ctx.list.goods_alias), 1)])) : _createCommentVNode("", true), _ctx.firTopUpGwc ? (_openBlock(), _createElementBlock("div", _hoisted_227, [_cache[132] || (_cache[132] = _createElementVNode("div", {
      class: "detail-left detail-left-four"
    }, "首", -1)), _createElementVNode("div", _hoisted_228, " 首充双倍额外积分：+" + _toDisplayString(_ctx.firTopUpGwc) + "积分 ", 1)])) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_229, [_cache[133] || (_cache[133] = _createElementVNode("div", {
      class: "detail-left detail-left-sec"
    }, "积", -1)), _ctx.firTopUpGwc == 0 ? (_openBlock(), _createElementBlock("div", _hoisted_230, " 合计：" + _toDisplayString(_ctx.totalPrice) + "积分 ", 1)) : (_openBlock(), _createElementBlock("div", _hoisted_231, " 合计：" + _toDisplayString(_ctx.finalPriceResult) + "积分 ", 1))])]), _createElementVNode("div", _hoisted_232, [_cache[139] || (_cache[139] = _createElementVNode("div", {
      class: "pay-choice-title"
    }, "支付方式", -1)), _createElementVNode("div", {
      class: _normalizeClass(["pay-choice-btn", [_ctx.payType == 'alipay' ? ' choice-pay-type' : '']]),
      onClick: _cache[36] || (_cache[36] = $event => _ctx.changePay('alipay'))
    }, [_cache[134] || (_cache[134] = _createElementVNode("div", {
      class: "alipay"
    }, [_createElementVNode("img", {
      src: _imports_0,
      alt: ""
    })], -1)), _cache[135] || (_cache[135] = _createElementVNode("div", {
      class: "pay-mid-title"
    }, "支付宝支付", -1)), _ctx.showAliPay ? (_openBlock(), _createElementBlock("div", _hoisted_233, "推荐")) : _createCommentVNode("", true)], 2), _createElementVNode("div", {
      class: _normalizeClass(["pay-choice-btn", [_ctx.payType == 'wechat' ? ' choice-pay-type' : '']]),
      onClick: _cache[37] || (_cache[37] = $event => _ctx.changePay('wechat'))
    }, _cache[136] || (_cache[136] = [_createElementVNode("div", {
      class: "wechat"
    }, [_createElementVNode("img", {
      src: _imports_1,
      alt: ""
    })], -1), _createElementVNode("div", {
      class: "pay-mid-title"
    }, "微信支付", -1)]), 2), _createElementVNode("div", {
      class: _normalizeClass(["pay-choice-btn", [_ctx.payType == 'pay_behalf' ? ' choice-pay-type' : '']]),
      onClick: _cache[38] || (_cache[38] = $event => _ctx.changePay('pay_behalf'))
    }, _cache[137] || (_cache[137] = [_createElementVNode("div", {
      class: "wechat"
    }, [_createElementVNode("img", {
      src: _imports_2,
      alt: ""
    })], -1), _createElementVNode("div", {
      class: "pay-mid-title"
    }, "找朋友帮忙付", -1)]), 2), _cache[140] || (_cache[140] = _createElementVNode("div", {
      class: "pay-tips"
    }, " 在进行支付时，由于支付渠道相关规则，可能出现超额提醒、限额提醒、风险提醒等，可切换支付方式后再次尝试 ", -1)), _createElementVNode("div", _hoisted_234, [_cache[138] || (_cache[138] = _createTextVNode(" 温馨提示：请您知悉，点击立即支付即视为您同意")), _createElementVNode("span", {
      onClick: _cache[39] || (_cache[39] = $event => _ctx.goRuler())
    }, "《青瓷游戏用户服务协议》")])])]), _createElementVNode("div", _hoisted_235, [_ctx.showType ? (_openBlock(), _createElementBlock("div", _hoisted_236, [_createElementVNode("div", _hoisted_237, [_cache[145] || (_cache[145] = _createElementVNode("div", {
      class: "pay-choice-title"
    }, "支付方式", -1)), _createElementVNode("div", {
      class: _normalizeClass(["pay-choice-btn", [_ctx.payType == 'alipay' ? ' choice-pay-type' : '']]),
      onClick: _cache[40] || (_cache[40] = $event => _ctx.changePay('alipay'))
    }, [_cache[141] || (_cache[141] = _createElementVNode("div", {
      class: "alipay"
    }, [_createElementVNode("img", {
      src: _imports_0,
      alt: ""
    })], -1)), _cache[142] || (_cache[142] = _createElementVNode("div", {
      class: "pay-mid-title"
    }, "支付宝支付", -1)), _ctx.showAliPay ? (_openBlock(), _createElementBlock("div", _hoisted_238, "推荐")) : _createCommentVNode("", true)], 2), _createElementVNode("div", {
      class: _normalizeClass(["pay-choice-btn", [_ctx.payType == 'wechat' ? ' choice-pay-type' : '']]),
      onClick: _cache[41] || (_cache[41] = $event => _ctx.changePay('wechat'))
    }, _cache[143] || (_cache[143] = [_createElementVNode("div", {
      class: "wechat"
    }, [_createElementVNode("img", {
      src: _imports_1,
      alt: ""
    })], -1), _createElementVNode("div", {
      class: "pay-mid-title"
    }, "微信支付", -1)]), 2), _createElementVNode("div", {
      class: _normalizeClass(["pay-choice-btn", [_ctx.payType == 'pay_behalf' ? ' choice-pay-type' : '']]),
      onClick: _cache[42] || (_cache[42] = $event => _ctx.changePay('pay_behalf'))
    }, _cache[144] || (_cache[144] = [_createElementVNode("div", {
      class: "wechat"
    }, [_createElementVNode("img", {
      src: _imports_2,
      alt: ""
    })], -1), _createElementVNode("div", {
      class: "pay-mid-title"
    }, "找朋友帮忙付", -1)]), 2)])])) : _createCommentVNode("", true), _ctx.scrollBot ? (_openBlock(), _createElementBlock("div", {
      key: 1,
      class: "now-pay-type",
      onClick: _cache[43] || (_cache[43] = $event => _ctx.showType = !_ctx.showType)
    }, [_cache[146] || (_cache[146] = _createElementVNode("div", {
      class: "pay-choice-title"
    }, "支付方式", -1)), _createElementVNode("div", _hoisted_239, [_createElementVNode("div", {
      class: _normalizeClass(_ctx.payTypeClass)
    }, null, 2), _createElementVNode("div", null, _toDisplayString(_ctx.payTypeText), 1), _createVNode(_component_van_icon, {
      name: "arrow-up"
    })])])) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_240, [_createElementVNode("div", _hoisted_241, [_cache[148] || (_cache[148] = _createTextVNode(" 合计：")), _createElementVNode("span", null, [_cache[147] || (_cache[147] = _createElementVNode("span", {
      class: "price-icon"
    }, "￥", -1)), _createTextVNode(_toDisplayString(_ctx.totalPrice), 1)])]), _createElementVNode("div", {
      class: "pay-btn",
      onClick: _cache[44] || (_cache[44] = $event => _ctx.gwcSetPay())
    }, "立即支付")])])], 512)]),
    _: 1
  }, 8, ["show"]), _createVNode(_component_van_popup, {
    show: _ctx.show,
    "onUpdate:show": _cache[50] || (_cache[50] = $event => _ctx.show = $event),
    onClosed: _cache[51] || (_cache[51] = $event => _ctx.closeRolePopup()),
    "close-on-click-overlay": false,
    "lock-scroll": ""
  }, {
    default: _withCtx(() => [_createElementVNode("div", _hoisted_242, [_createElementVNode("div", _hoisted_243, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.gameRoleList, (item, index) => {
      return _openBlock(), _createElementBlock("div", {
        key: item.game_id,
        class: _normalizeClass(["choice-block", {
          active: _ctx.gameRoleTitle == item.title
        }]),
        onClick: $event => _ctx.chooseSystem(item, index)
      }, _toDisplayString(item.title), 11, _hoisted_244);
    }), 128))]), _createElementVNode("div", _hoisted_245, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.areaList, item => {
      return _openBlock(), _createElementBlock("label", {
        class: _normalizeClass(["role-list-container", {
          actives: _ctx.chooseGameList.role_id == item.role_id
        }]),
        for: item.role_id,
        key: item.role_id
      }, [_createElementVNode("div", _hoisted_247, [_createElementVNode("div", _hoisted_248, [_createElementVNode("div", _hoisted_249, [_createElementVNode("span", null, _toDisplayString(item.nickname), 1), item.is_last_pay == 1 ? (_openBlock(), _createElementBlock("span", _hoisted_250, "最近充值")) : _createCommentVNode("", true)]), _createElementVNode("div", _hoisted_251, [_createElementVNode("span", null, "区服: " + _toDisplayString(item.dist_name), 1), item.score ? (_openBlock(), _createElementBlock("span", _hoisted_252, "综合战力: " + _toDisplayString(item.score), 1)) : _createCommentVNode("", true)])])]), _withDirectives(_createElementVNode("input", {
        type: "radio",
        id: item.role_id,
        value: item,
        name: "role",
        "onUpdate:modelValue": _cache[48] || (_cache[48] = $event => _ctx.chooseGameList = $event),
        onChange: $event => _ctx.chooseRoleGameId(item)
      }, null, 40, _hoisted_253), [[_vModelRadio, _ctx.chooseGameList], [_vShow, _ctx.roleList.role_id != item.role_id]]), _ctx.roleList.role_id == item.role_id ? (_openBlock(), _createElementBlock("div", _hoisted_254, " 当前角色 ")) : _createCommentVNode("", true)], 10, _hoisted_246);
    }), 128))]), _createElementVNode("div", {
      class: "role-btn",
      onClick: _cache[49] || (_cache[49] = $event => _ctx.confirmChoose())
    }, "确定")])]),
    _: 1
  }, 8, ["show"]), _createVNode(_component_van_popup, {
    show: _ctx.showWechatCode,
    "onUpdate:show": _cache[52] || (_cache[52] = $event => _ctx.showWechatCode = $event),
    onClosed: _cache[53] || (_cache[53] = $event => _ctx.closeQrcode())
  }, {
    default: _withCtx(() => [_createElementVNode("div", _hoisted_255, [_createElementVNode("div", _hoisted_256, null, 512), _cache[149] || (_cache[149] = _createElementVNode("div", {
      class: "title"
    }, "请使用微信扫码付款", -1))])]),
    _: 1
  }, 8, ["show"]), _createVNode(_component_van_popup, {
    show: _ctx.showWechatAlipay,
    "onUpdate:show": _cache[55] || (_cache[55] = $event => _ctx.showWechatAlipay = $event),
    style: {
      width: '100%',
      height: '100%'
    }
  }, {
    default: _withCtx(() => [_createElementVNode("div", {
      class: "wechat-alipay-popup",
      onClick: _cache[54] || (_cache[54] = $event => _ctx.closeWechatAlipay())
    })]),
    _: 1
  }, 8, ["show"]), _createVNode(_component_van_popup, {
    show: _ctx.realNamePopup,
    "onUpdate:show": _cache[61] || (_cache[61] = $event => _ctx.realNamePopup = $event)
  }, {
    default: _withCtx(() => [_createElementVNode("div", _hoisted_257, [_createElementVNode("div", _hoisted_258, [_createElementVNode("div", _hoisted_259, [_createElementVNode("div", {
      class: "close",
      onClick: _cache[56] || (_cache[56] = $event => _ctx.realNamePopup = false)
    }), _createElementVNode("div", {
      onClick: _cache[57] || (_cache[57] = $event => _ctx.kfBtn()),
      class: "some-trouble"
    }, "遇到问题？")])]), _createElementVNode("div", _hoisted_260, [_cache[152] || (_cache[152] = _createElementVNode("div", {
      class: "real-name-title"
    }, "实名认证", -1)), _createElementVNode("div", _hoisted_261, [_createElementVNode("div", _hoisted_262, [_withDirectives(_createElementVNode("input", {
      type: "text",
      placeholder: "请输入姓名",
      "onUpdate:modelValue": _cache[58] || (_cache[58] = $event => _ctx.userName = $event)
    }, null, 512), [[_vModelText, _ctx.userName]]), _cache[150] || (_cache[150] = _createElementVNode("div", {
      class: "input-title"
    }, [_createElementVNode("div", {
      class: "phone"
    })], -1))])]), _createElementVNode("div", _hoisted_263, [_createElementVNode("div", _hoisted_264, [_withDirectives(_createElementVNode("input", {
      type: "text",
      placeholder: "请输入身份证号",
      class: "sec-input",
      "onUpdate:modelValue": _cache[59] || (_cache[59] = $event => _ctx.cardIdNum = $event)
    }, null, 512), [[_vModelText, _ctx.cardIdNum]]), _cache[151] || (_cache[151] = _createElementVNode("div", {
      class: "input-title"
    }, [_createElementVNode("div", {
      class: "sms"
    })], -1))])]), _createElementVNode("div", _hoisted_265, [_createElementVNode("button", {
      onClick: _cache[60] || (_cache[60] = $event => _ctx.updataUserBtn())
    }, "提交认证")]), _cache[153] || (_cache[153] = _createElementVNode("div", {
      class: "real-name-bot-title"
    }, " 根据《关于进一步严格管理切实防止未成年人沉迷网络游戏的通知》《关于防止未成年人沉迷网络游戏工作的通知》等法规要求需要各位玩家进行实名认证。 ", -1))])])]),
    _: 1
  }, 8, ["show"]), _createVNode(_component_van_popup, {
    show: _ctx.shareImgPopup,
    "onUpdate:show": _cache[64] || (_cache[64] = $event => _ctx.shareImgPopup = $event),
    "close-on-click-overlay": false
  }, {
    default: _withCtx(() => [_createElementVNode("div", _hoisted_266, [_createElementVNode("img", {
      src: _imports_4,
      alt: "",
      onClick: _cache[62] || (_cache[62] = $event => _ctx.shareImgPopup = false)
    })]), _ctx.list.suspension_button_img ? (_openBlock(), _createElementBlock("div", _hoisted_267, [_createElementVNode("img", {
      src: _ctx.list.suspension_back_img,
      alt: ""
    }, null, 8, _hoisted_268), _createElementVNode("div", _hoisted_269, _toDisplayString(_ctx.list.suspension_link), 1)])) : _createCommentVNode("", true), _createElementVNode("div", {
      class: "share-btn",
      onClick: _cache[63] || (_cache[63] = $event => _ctx.copy()),
      "data-clipboard-text": _ctx.list.suspension_link,
      id: "copyBtn"
    }, " 复制并分享 ", 8, _hoisted_270)]),
    _: 1
  }, 8, ["show"])]);
}